
/**
 *  UI_NAMES contain all the constants to build proper name properties for the
 * DOM elements
 */

export default {
  /**
   * Login View
   */
  LOGIN_USERNAME_INPUT: 'username',
  LOGIN_PASSWORD_INPUT: 'password',

  /**
   * Drawer
   */
  HOME_MENU_ITEM: 'home-menu-item',
  RESOURCE_VIEW_MENU_ITEM: {
    with: ({ resourceName, view }) => `${resourceName}-${view}-menu-item`
  }
}



// WEBPACK FOOTER //
// ./src/layout/constants/ui.names.js